import {
  HTTP_GETPROJECTDETAIL_FETCHING,
  HTTP_GETPROJECTDETAIL_SUCCESS,
  HTTP_GETPROJECTDETAIL_FAILED,
} from "././../../Constants";

const initialState = {
  result: null,
  isLoading: false,
  isError: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_GETPROJECTDETAIL_FETCHING:
      return {
        ...state,
        result: null,
        isLoading: true,
        isError: false,
      };
    case HTTP_GETPROJECTDETAIL_SUCCESS:
      return {
        ...state,
        result: payload,
        isLoading: false,
        isError: false,
      };
    case HTTP_GETPROJECTDETAIL_FAILED:
      return {
        ...state,
        result: null,
        isLoading: false,
        isError: true,
      };
    default:
      return state;
  }
};
